import React from "react";

const CountryPrices = () => {
	const imageText = {
		textAlign: "center",
		alignItems: "center",
		margin: "0 1rem",
		color: "rgb(167,167,167)",
		fontSize: ".9rem"
	};

	const blockText = {
		margin: "0.5rem 0",
		textAlign: "center"
	};

	const image = {
		maxWidth: "4rem",
		maxHeight: "4rem"
	};

	const imageNotShow = {
		marginBottom: "0.4rem"
	};

	const block = {
		textAlign: "center",
		alignItems: "center",
		marginTop: "1rem"
	};

	return (
		<div>
			<div className="countriesContainer">
				<div className="countriesBlock notShow">
					<img
						style={{ ...image, ...imageNotShow }}
						alt="IN"
						src={"/skaiciuokle/img/IN.png"}
					/>
					<div style={imageText}>
						<div style={blockText}>Vid. val. kaina Indijoje</div>
						<div>25€/VAL.</div>
					</div>
				</div>

				<div className="mediaParent">
					<img
						alt="MediaPulsas"
						className="mediaLogo"
						src={"/skaiciuokle/img/mainLogo.png"}
					/>
					<div className="mediaLogoText">
						<div style={blockText}>Mediapulsas.lt</div>
						<div>30€/VAL.</div>
					</div>
				</div>

				<div style={block}>
					<img
						style={{ ...image, ...imageNotShow }}
						alt="LT"
						src={"/skaiciuokle/img/LT.png"}
					/>
					<div style={imageText}>
						<div style={blockText}>Vid. val. kaina Lietuvoje</div>
						<div>35€/VAL.</div>
					</div>
				</div>

				<div className="countriesBlock notShow">
					<img
						style={{ ...image, ...imageNotShow }}
						alt="ES"
						src={"/skaiciuokle/img/ES.png"}
					/>
					<div style={imageText}>
						<div style={blockText}>Vid. val. kaina ES</div>
						<div>60€/VAL.</div>
					</div>
				</div>

				<div className="countriesBlock notShow">
					<img
						style={{ ...image, ...imageNotShow }}
						alt="JAV"
						src={"/skaiciuokle/img/JAV.png"}
					/>
					<div style={imageText}>
						<div style={blockText}>Vid. val. kaina JAV</div>
						<div>80€/VAL.</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CountryPrices;
